import { useActiveMembership } from '@batiflow/client-core/react';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { visibleFinanceSections } from '@/features/finance';
import { NotFound } from '@/shared/components/route-states';

function FinanceHome() {
  const { orgId } = Route.useParams();
  const membership = useActiveMembership();
  const first = visibleFinanceSections(membership?.permissions)[0];
  if (!first) return <NotFound />;
  return <Navigate to={first.to} params={{ orgId }} replace />;
}

/** `/o/$orgId/finance`: opens the first Finance section the member may see. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/')({
  component: FinanceHome,
});
